import React from 'react';
import {
  Text,
  View,
  StyleSheet,
  TouchableWithoutFeedback,
} from 'react-native';

import Theme from '../../theme';

function DisplaySettingsTabs(props) {
  const {
    availableTabs,
    setActiveTab,
    routes,
    jumpToIndex,
    currentTabIndex,
  } = props;
  return (
    <View style={styles.container}>
      {routes.map((route, index) => {
        const activeTab = availableTabs[index];
        const active = index === currentTabIndex;

        const backgroundColor = Theme.WHITE;

        const textColor = active
          ? Theme.PRIMARY
          : Theme.GREY;

        const fontFamily = active
          ? Theme.CustomBold
          : Theme.CustomNormal;

        const borderInactiveStyles = {
          borderWidth: 0,
          borderColor: Theme.GREY_LIGHT,
        };

        const borderActiveStyles = {
          borderWidth: 0,
          borderBottomWidth: 5,
          borderColor: Theme.PRIMARY,
        };

        const borderStyles = active
          ? borderActiveStyles
          : borderInactiveStyles;
        return (
          <TouchableWithoutFeedback
            key={route.key}
            onPress={() => {
              jumpToIndex(index);
              setActiveTab(index);
            }}>
            <View
              style={[styles.tab, {
                backgroundColor,
                ...borderStyles,
              }]}>

              <Text style={[styles.weekdayText, {
                color: textColor, fontFamily: fontFamily,
              }]}>
                {activeTab}
              </Text>
            </View>
          </TouchableWithoutFeedback>
        );
      })}
    </View>
  );
}

DisplaySettingsTabs.propTypes = {
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    height: 60,
    borderTopWidth: 0,
    borderBottomWidth: 1,
    paddingTop: 10,
    flexDirection: 'row',
    alignContent: 'center',
    justifyContent: 'center',
    borderColor: Theme.GREY_LIGHT,
  },
  tab: {
    flex: 1,
    padding: 3,
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
  },
  weekdayText: {
    fontSize: 16,
    alignItems: 'center',
    color: Theme.GREY,
  },
});

export default DisplaySettingsTabs;
